module.exports = __webpack_public_path__ + "app/assets/images/woman15-5a83c1aad1dae93690a97a7136cccf23.jpg";